import React from 'react'
import range from 'lodash.range'
import {useStore} from '../Store/useStore'
import Journal from './Journal'

const PaginatedJournals = ({className}) => {
    const ITEMS_PER_PAGE = useStore((state) => state.itemsPerPage)
    const paginationType = useStore((state) => state.paginationType)

    const journals = useStore((state) => state.filteredAndSearchedJournals)()

    const totalRecords = journals.length
    const totalPages = Math.ceil(totalRecords / ITEMS_PER_PAGE)
    const pageNumbers = range(1, totalPages + 1)

    const currentPage = useStore((state) => state.currentPage)
    const setCurrentPage = useStore((state) => state.setCurrentPage)
    const translations = useStore((state) => state.translations)

    const getJournalsForCurrentPage = () => {
        let startIndex = 0
        if (paginationType === 'pagination') {
            startIndex = currentPage * ITEMS_PER_PAGE
        } else if (paginationType === 'load-more') {
            startIndex = 0
        }
        const endIndex = Math.min((currentPage + 1) * ITEMS_PER_PAGE, totalRecords)
        return journals.slice(startIndex, endIndex)
    }

    const pageText = () => {
        if (paginationType !== 'pagination') {
            return null
        }

        let pageText = translations.pageText
        pageText = pageText.replace('{0}', currentPage + 1)
        pageText = pageText.replace('{1}', totalPages)
        return pageText
    }

    const getPaginationType = () => {
        if (paginationType === 'pagination') {
            return getPagination()
        } else if (paginationType === 'load-more') {
            return getLoadMore()
        }
    }

    const getPagination = () => {
        if (totalPages <= 1) {
            return null
        }

        return (
            <nav aria-label="Journals navigation" className="journal-list__pagination-wrapper">
                <ul className="journal-list__pagination">
                    <li className={"journal-list__pagination-backward " + (currentPage === 0 ? 'disabled' : '')}>
                        <a className="journal-list__pagination-link"
                           onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}>
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>

                    {pageNumbers.map((page, index) => (
                        <li className={"journal-list__pagination-page journal-list__pagination-page--" + (index + 1) + " "
                            + (index === currentPage ? 'active' : '')}
                            key={index}>
                            <a className="journal-list__pagination-link"
                               onClick={() => setCurrentPage(index)}>{page}</a>
                        </li>
                    ))}

                    <li className={"journal-list__pagination-forward " + (currentPage === totalPages - 1 ? 'disabled' : '')}>
                        <a className="journal-list__pagination-link"
                           onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages - 1))}>
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        )
    }

    const getLoadMore = () => {
        // Don't show load more button, when there are no more pages to load
        if (totalPages <= 1 || currentPage >= totalPages - 1) {
            return null
        }

        return (
            <a className="journals__load-more"
               onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages - 1))}>
                {translations.loadMore}
            </a>
        )
    }

    return (
        <div className={className}>
            <div className="journal-list__result-header">
                <div className="journal-list__pagination-information">
                    <div className="journal-list__pagination-information--page">{pageText()}</div>
                    <div className="journal-list__pagination-information--results">
                        {totalRecords + " " + translations.results}
                    </div>
                </div>
            </div>
            <div className="journal-list__result-list">
                {getJournalsForCurrentPage().map((journal, index) => (
                    <Journal resultItem={journal} key={index}/>
                ))}
            </div>
            {getPaginationType()}
        </div>
    )
}
export default PaginatedJournals
